import styled from 'styled-components'

const Section = styled.div `
  box-sizing: border-box;
  padding: 30px;
  position: relative;
`

Section.White = styled(Section) `
  background: #FFFFFF;
`

Section.Lighter = styled(Section) `
  background: #FAFAFA;
`

Section.Light = styled(Section) `
  background: #F1F1F1;
`

Section.Dark = styled(Section) `
  background: #393939;
`

export { Section }
